module.exports = __webpack_public_path__ + "img/empty-box.png";